import { render, staticRenderFns } from "./settingFontSize.vue?vue&type=template&id=69178036&"
import script from "./settingFontSize.vue?vue&type=script&lang=js&"
export * from "./settingFontSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/settingFontSize.vue"
export default component.exports